import React, { useMemo } from "react";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/Invoice.scss";
import Table from "../../Components/Table";
import { Link, useLocation } from "react-router-dom";
import Invoicefilter from "../../Components/Invoice-filter";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { deleteInvoices, getCurrencyList, getInvoices, getSystemSettings } from "../../Services/Invoices/action";
import qs from "query-string";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";

const status = {
  "Draft": "pending",
  "Sent": "inprogress",
  "Partially Paid": "partially-pay",
  "Paid": "success"
}

const Invoice = (props) => {
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [params, setParams] = useState({});
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportrLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inData, setInData] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);

  const header = [
    { field: "checkbox" },
    { field: "Clients" },
    { field: "Date" },
    { field: "Amount(INR)" },
    { field: "Amount(~)" },
    { field: "Share Holders" },
    { field: "Status" },
    { field: "Action" },
  ];

  let footer = true;
  let count = props.invoices?.length;

  // TODO: try with async flow
  useEffect(() => {
    setIsLoading(true)
    props.getCurrencyList();
    props.getSystemSettings();
    fetchData();
    setIsLoading(false)
  }, [location.search]);

  const fetchData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getInvoicesList(location.search);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };


  const showToastMessage = (error) => {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  useEffect(() => {
    props.invoices
      ? setInData(
        props.invoices?.map((invoice) => {
          const shareHolder = new Set();
          invoice?.invoiceTransactionMap?.map((invoiceTransaction) => {
            invoiceTransaction?.transactionInvoiceMap?.transactionShareHolderMap?.map(
              (tranShalehoder) => {
                shareHolder.add(
                  tranShalehoder?.shareHolderTransactionMap?.name
                );
              }
            );
          });

          const DefaultCurrencyCode = props?.systemsettings?.find((item) => item?.key)?.value;

          const DefaultCurrencySymbol = props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;

          const currencycode = props?.currencylist?.find((item) => item.id === invoice?.currency_id)?.code

          const filtercurrencycode = (currencycode === DefaultCurrencyCode ?
            "-" :
            `${invoice.total || 0} (${currencycode || "-"})`);

          return {
            checkbox: {
              value: invoice.id,
              type: "checkbox",
            },
            Clients: {
              value: invoice.clientInvoices.name,
              value2: invoice.clientInvoices.email,
              title: invoice.title,
              type: "client",
            },
            Date: {
              value: invoice.date.split(" ")[0],
              type: "date",
            },
            "Amount(INR)": {
              value: `${DefaultCurrencySymbol || ""}${invoice.total * invoice.currency_rate || 0}`,
              type: "amount",
            },
            "Amount(~)": {
              value: filtercurrencycode,
              type: "amount",
            },
            "Share Holders": {
              // value:shareHolder.toString(),
              value: Array.from(shareHolder).map((item) => ({ name: item })),
              // value: invoice?.shareHolders?.map((shareHolder) => {
              //   let value = {
              //     name: shareHolder.name,
              //   };
              //   if (shareHolder.src) {
              //     value = {
              //       ...value,
              //       src: shareHolder.src,
              //     };
              //   }
              //   return value;
              // }),
              type: "share holder",
            },
            Status: {
              value: `${status[invoice.status]}`,
              type: 'status'
            },
            Action: {
              value: "/invoice/edit",
              value2: "/invoice/view",
              type: "action",
            },
            invoiceId: {
              value: invoice.id,
            },

          };
        })
      )
      : setInData([]);
  }, [props.invoices]);

  const handleChange = (e) => {
    if (e[1] == "headerAll" && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== "headerAll") {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == "headerAll" && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };

  // When Click on Delete or Export Button
  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      // Deletion Function 
      if (type === "delete") {
        setDeleteLoading(true);
        // Wait for the deletion to complete before moving on
        await props.deleteInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === "export") {
        setExportrLoading(true);
        await handlePdfDownload(ids);
        toast.success("Exported Successfully");
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (!props.loading && props.success) {
        await fetchData();
      }
      setDeleteLoading(false);
    }
  };

  // Pdf downloading API Calling
  const handlePdfDownload = async (ids) => {
    try {
      for (let id of ids) {
        let result = await api(
          `invoices/generate/pdf`,
          "post",
          { ids: [id] },
          getAuthHeader(),
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(result.data);
        downloadURI(url, `${id}.pdf`);
      }
      setExportrLoading(false);
    } catch (error) {
      let errorMessage = error?.message;
      showToastMessage(errorMessage);
      setExportrLoading(false);
    }
  };

  function downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  return (
    <Sidebarlayout>
      <div className="invoice-main">
        <div className="page-title">
          <h4>Invoice</h4>
          <div className="edit-btn">
            <button
              className="export-btn"
              id="exportBtn"
              disabled={!checked || exportLoading}
              onClick={(e) => {
                e.preventDefault();
                handleClick(totalSelectedIds, "export");
              }}
            >
              {exportLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Export"
              )}
            </button>
            <button
              className="delete-btn"
              id="deleteBtn"
              disabled={!checked || deleteLoading}
              onClick={(e) => {
                e.preventDefault();
                handleClick(totalSelectedIds, "delete");
              }}
            >
              {deleteLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Delete"
              )}
            </button>
            <button type="button" className="custom-btn">
              <Link
                to="/invoice/add"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Add"
                )}
              </Link>
            </button>
          </div>
        </div>
        <ToastContainer />
        <div className="filter-part">
          <Invoicefilter filter={params} />
        </div>
        <div className="invoice-table-part">
          <Table
            header={header}
            data={inData}
            footer={footer}
            count={count}
            checked={checked}
            records={parseFloat(props.records)}
            totalSelectedIds={totalSelectedIds}
            defaultParams={params}
            selectedId={selectedId}
            handleChange={handleChange}
            loading={props.loading}
          />
        </div>
      </div>
    </Sidebarlayout>
  );
};

export const mapStateToProps = (state) => {
  return {
    invoices: state.invoicesReducer.invoices.rows,
    count: state.invoicesReducer.invoices.count,
    loading: state.invoicesReducer.loading,
    success: state.invoicesReducer.success,
    records: state.invoicesReducer.invoices.noOfRecords,
    currencylist: state.invoicesReducer.currencylist,
    systemsettings: state.invoicesReducer.systemsettings,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getInvoicesList: (params) => {
      dispatch(getInvoices(params));
    },
    deleteInvoices: (ids) => {
      dispatch(deleteInvoices(ids));
    },
    getCurrencyList: () => {
      dispatch(getCurrencyList())
    },
    getSystemSettings: () => {
      dispatch(getSystemSettings())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
